// extracted by mini-css-extract-plugin
export default {"ChangePassword":"style_ChangePassword__1rw8f","btnHolder":"style_btnHolder__Ob8+V"};